import { Formio } from '@formio/angular';

/**
 * Registers a custom Formio Select component that uses the native HTML5 <select>
 * when rendered inside a dialog. This avoids Choices.js dropdowns rendering behind
 * the modal (native <dialog> top layer).
 *
 * Call this once after Formio.use(premium) in the app config.
 */
export function registerFormioSelectForModal(): void {
  const BaseSelect = Formio.Components.components['select'];
  if (!BaseSelect) return;

  class SelectInModalComponent extends BaseSelect {
    attach(element: HTMLElement) {
      const self = this as unknown as { component: { widget?: string }; root?: { element?: HTMLElement } };
      const isInDialog = element?.closest?.('dialog') ?? self.root?.element?.closest?.('dialog');
      // Leave widget as 'html5' for the component's lifetime when in a dialog so that
      // options loaded asynchronously (setItems → addOption) still append to the native select.
      if (isInDialog && self.component) {
        self.component.widget = 'html5';
      }
      return super.attach(element);
    }
  }

  Formio.Components.addComponent('select', SelectInModalComponent);
}
